<div class="manual-dialog-header">
    Add waste data manually for {{shiftMachineData?.popupData?.name}}
</div>
<div class="manual-dialog-wrapper">
    <div class="content-wrapper">
        <ng-container *ngIf="shiftList && shiftList.length > 0 || !manualServiceCall || isUpdate; else noData">
            <form [formGroup]="multiShiftDetails" class="shift-form" *ngIf="multiShiftDetails">
                <div class="date-wrapper">
                    <mat-form-field appearance="fill" class="mat-date-field">
                        <mat-label>{{'common.date' | translate}}</mat-label>
                        <input matInput [matDatepicker]="datePicker" [min]="minimumDate" [max]="maximumDate"
                            formControlName="datePickerValue" (dateChange)="dateSelected()">
                        <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                        <mat-datepicker #datePicker disabled="false" panelClass="manual-datepicker"></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="dynamic-field-wrapper">
                    <ng-container *ngIf="shiftValue && shiftValue.value && shiftValue.value.length > 0">
                        <ng-container *ngFor="let shift of shiftValue.controls; let index = index">
                            <div [formGroup]="shift" class="shift-wrapper">
                                <div class="shift-field-wrapper">
                                    <mat-form-field class="mat-shift" appearance="outline">
                                        <mat-label>
                                            {{'common.shift' | translate}}
                                        </mat-label>
                                        <mat-select formControlName="shift" (selectionChange)="onShiftChange(index)">
                                            <mat-option *ngFor="let currentShift of shiftList" [value]="currentShift">
                                                {{currentShift.shiftName}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <mat-form-field class="mat-sku" appearance="outline">
                                        <mat-label>
                                            {{'search.sku' | translate}}
                                        </mat-label>
                                        <mat-select formControlName="sku"
                                            (selectionChange)="onSkuChange($event.value, index)">
                                            <mat-option *ngFor="let sku of getSKUArray(index).controls"
                                                [value]="sku.get('skuName').value" title="{{sku.get('skuName').value}}">
                                                {{sku.get('skuName').value}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-hint class="error-msg skill-error"
                                            *ngIf="shift.get('sku').errors && shift.get('sku').errors.duplicate">
                                            {{'machine_view.manual_popup.already_selected_sku' | translate}}
                                        </mat-hint>
                                    </mat-form-field>

                                    <mat-form-field class="mat-sku" appearance="outline">
                                        <mat-label>
                                            {{'machine_view.manual_popup.total_waste_in_pc' | translate}}
                                        </mat-label>
                                        <input type="text" matInput formControlName="actualValue"
                                            (keypress)="checkNumberOnly($event, index, 'actualValue')">
                                    </mat-form-field>

                                    <mat-form-field class="mat-sku" appearance="outline">
                                        <mat-label>
                                            {{'machine_view.actual_percentage' | translate}}
                                        </mat-label>
                                        <input type="number" matInput formControlName="actualPercentage"
                                            (keypress)="checkNumberOnly($event, index, 'actualPercentage')">
                                    </mat-form-field>
                                </div>

                                <div class="removeShift" *ngIf="(index === 0 && isUpdate) || index !== 0">
                                    <img src="assets/images/dialog-close.svg" alt="close" class="dialog-close-img"
                                         (click)="removeShift(index)"
                                        (keydown)="($event.key === 'Enter' || $event.key === ' ') ? removeShift(index) : null">

                                </div>
                            </div>
                        </ng-container>
                    </ng-container>

                    <div class="add-shift-btn">
                        <button mat-flat-button class="btn" (click)="addShift()">
                            <mat-icon class="icon">add</mat-icon>
                        </button>
                    </div>
                </div>
            </form>
        </ng-container>
        <ng-template #noData>
            <div class="no-data-wrapper">
                <span class="content-span">
                    {{'machine_view.manual_popup.no_data' | translate}}
                </span>
                <button class="btn btn-primary content-btn" (click)="dialogClose()">OK</button>
            </div>
        </ng-template>
    </div>

    <div class="button-wrapper" *ngIf="shiftList && shiftList.length > 0 || !manualServiceCall || isUpdate">
        <button mat-flat-button class="cancel-btn" (click)="dialogClose()">
            {{'common.CANCEL' | translate}}
        </button>

        <button mat-flat-button class="save-btn" [ngClass]="{'disabled-btn': multiShiftDetails.status !== 'VALID'}"
            (click)="saveClicked()" [disabled]="multiShiftDetails.status !== 'VALID'">
            {{'common.save' | translate}}
        </button>
    </div>
</div>